var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourceTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_82047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9831 7.22252C20.982 6.89832 20.9522 6.57486 20.8941 6.25592C20.8293 5.86598 20.7061 5.48804 20.5287 5.13482C20.3344 4.76355 20.0815 4.4261 19.7796 4.13552C19.3235 3.6895 18.7603 3.36838 18.1442 3.20304C17.5783 3.06595 16.9969 3.00397 16.4148 3.01869L16.4115 3.00977H7.58572L7.5852 3.01869C7.25413 3.01605 6.92314 3.03085 6.59363 3.06302C6.23255 3.10155 5.87713 3.1816 5.5344 3.30159C4.96982 3.51418 4.46333 3.85691 4.05604 4.30195C3.64876 4.747 3.35217 5.28182 3.19035 5.86299C3.05419 6.42384 2.99219 7.00013 3.00593 7.57712L3 16.4315C3.00569 16.8324 3.03293 17.2328 3.0816 17.6309C3.14171 18.051 3.26595 18.4595 3.45 18.842C3.7097 19.3526 4.07931 19.7993 4.53225 20.15C4.85599 20.4077 5.22266 20.6063 5.6154 20.7366C6.19197 20.9147 6.79255 21.0028 7.39598 20.9979C7.77353 21.0003 8.15115 21.0098 8.52892 21.0082C11.2732 20.9966 14.0173 21.028 16.7615 20.9912C17.124 20.9834 17.4853 20.945 17.8415 20.8766C18.5146 20.7584 19.1411 20.4538 19.65 19.9976C20.2492 19.4773 20.6676 18.7801 20.8448 18.0066C20.954 17.4889 21.0062 16.9607 21.0004 16.4316V16.3261C21 16.285 20.9845 7.34072 20.9831 7.22252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.484 2H6.51602C4.02189 2 2 4.03125 2 6.53693V17.4631C2 19.9687 4.02189 22 6.51602 22H17.484C19.9781 22 22 19.9687 22 17.4631V6.53693C22 4.03125 19.9781 2 17.484 2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1961 7H16.8998L13.1777 11.2361L17.5564 17H14.1277L11.4424 13.5045L8.36933 17H6.66465L10.6457 12.4694L6.44531 7H9.96081L12.3881 10.1954L15.1961 7ZM14.598 15.9846H15.5423L9.44809 7.96229H8.4349L14.598 15.9846Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_82047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceTwitter);
export default __webpack_public_path__ + "static/media/source-twitter.32c18d4f6b265454c96655ebf3957ad9.svg";
export { ForwardRef as ReactComponent };